<template>
  <div>
    <footer class="footer py-4">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-4 text-lg-left">Copyright &copy; Shanto's Blcakbox {{ new Date().getFullYear() }}</div>
          <div class="col-lg-4 my-3 my-lg-0">
            <a class="btn btn-dark btn-social mx-2" href="#!">
              <i class="fab fa-twitter"></i>
            </a>
            <a class="btn btn-dark btn-social mx-2" href="#!">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a class="btn btn-dark btn-social mx-2" href="#!">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div>
          <div class="col-lg-4 text-lg-right">
            <a class="mr-3" href="#!">Privacy Policy</a>
            <a href="#!">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>